module.exports = __webpack_public_path__ + "img/table-icon.c16d7678.svg";